import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, MapPin, Phone, Mail, Clock } from "lucide-react";
import { LOGO_URL, COMPANY } from "../data/store";

const institucional = [
  { label: "Sobre nós", to: "/sobre" },
  { label: "Nossa loja", to: "/sobre" },
  { label: "Contato", to: "/sobre" },
  { label: "Trabalhe conosco", to: "/sobre" },
];

const atendimento = [
  "Central de atendimento",
  "Política de entrega",
  "Trocas e devoluções",
  "Dúvidas frequentes",
];

const accountLinks = [
  { label: "Minha conta", to: "/conta" },
  { label: "Meus pedidos", to: "/pedidos" },
  { label: "Carrinho", to: "/carrinho" },
  { label: "Favoritos", to: "/conta" },
];

const Footer = () => (
  <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="col-span-2 lg:col-span-2">
          <div className="bg-white inline-flex rounded-lg p-2">
            <img src={LOGO_URL} alt="Sulbel" className="h-14 w-14 object-contain" />
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">
            A Sulbel Materiais Elétricos fornece cabos, extensões, terminais e acessórios
            para instalações elétricas, automotivas e energia solar — com envio rápido
            para todo o Brasil.
          </p>
          <ul className="mt-5 space-y-2 text-sm text-slate-400">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-brand mt-0.5 shrink-0" /> {COMPANY.address}</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-brand shrink-0" /> {COMPANY.phone}</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand shrink-0" /> {COMPANY.email}</li>
            <li className="flex items-start gap-2"><Clock className="h-4 w-4 text-brand mt-0.5 shrink-0" /> {COMPANY.hours}</li>
          </ul>
          <div className="mt-5 flex items-center gap-3">
            {[
              { icon: Instagram, label: "Instagram", href: "#" },
              { icon: Facebook, label: "Facebook", href: "#" },
              { icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/${COMPANY.whatsapp}` },
            ].map(({ icon: Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="h-10 w-10 rounded-full bg-slate-800 hover:bg-brand flex items-center justify-center transition-colors"
              >
                <Icon className="h-5 w-5 text-white" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4">Institucional</h3>
          <ul className="space-y-2.5">
            {institucional.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-slate-400 hover:text-brand transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4">Atendimento</h3>
          <ul className="space-y-2.5">
            {atendimento.map((l) => (
              <li key={l}><a href="#" className="text-sm text-slate-400 hover:text-brand transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4">Minha conta</h3>
          <ul className="space-y-2.5">
            {accountLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-slate-400 hover:text-brand transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {COMPANY.legal} — CNPJ {COMPANY.cnpj}. Todos os direitos reservados.
      </div>
    </div>
  </footer>
);

export default Footer;
